<template>
  <div class="housManage">
    <div class="areaSelect">
      <div class="head">
        <!-- 标题 -->
        <p>{{title.title}}</p>
        <i class="el-icon-close" @click="tipHide"></i>
      </div>
      <div class="housManageNav">
        <label class="ft14 col-33 mar-l">{{title.label1}}：</label>
        <div class="inp">
          <el-input v-model="numInp" placeholder="请输入" size="mini"></el-input>
        </div>
        <label class="ft14 col-33 mar-l" v-if="title.label2">{{title.label2}}：</label>
        <div class="inp" v-if="title.label2">
          <el-input v-model="nameInp" placeholder="请输入" size="mini"></el-input>
        </div>
        <ps-search @click="query"></ps-search>
      </div>
      <div class="dataList">
        <el-table
          highlight-current-row
          @current-change="handleCurrentChange"
          @row-dblclick="doubleClick"
          @select="select"
          @select-all="selectAll"
          :data="dataList"
          border
          height="280"
          v-loading="loading"
          style="width: 100%"
          ref="houseTable"
        >
          <slot></slot>
        </el-table>
      </div>

      <div class="pagination">
        <slot name="pagination">
          <!-- <el-pagination
            small
            @current-change="pageCurrentChange"
            @size-change="handleSizeChange"
            :current-page="currentPage"
            :page-sizes="[20, 40, 60, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>-->
        </slot>
      </div>
      <div class="housManageFoot">
        <div class="btn">
          <ps-sure @click.native="handelSure"></ps-sure>
          <ps-cancel @click.native="tipHide"></ps-cancel>
        </div>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { OrgUserMgeControllerSvr } from "@/service/OrgUserMgeControllerSvr/OrgUserMgeControllerSvr.js";
export default {
  data() {
    return {
      isMessage4: "true",
      total: "", //总页
      currentPage: 1, //当前页
      pageSize: 20,
      numInp: "",
      nameInp: "",
      propertyValArr: [],
      propertyValArr1: [],
      propertyVal: "", //选中的物业区域
      table: "机构",
      tableData: [],
      loading: true
    };
  },
  props: [
    "title",
    "dataList",
    "page",
    "selectedArr",
    "hadSelectArr",
    "isMessage3",
    "query1"
  ],
  watch: {
    selectedArr: {
      handler() {}
    },
    isMessage3: {
      handler() {}
    },
    dataList: {
      handler: function() {
        if (this.dataList) {
          this.loading = false;
          this.total = this.page.getCurrtNum;
          // this.tableData = this.dataList.slice(
          //   this.pageSize * (this.currentPage - 1),
          //   this.pageSize * this.currentPage
          // );
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState(["token", "userInfo"])
  },
  created() {
    if (this.query1.numInp) {
      this.numInp = this.query1.numInp;
    }
    if (this.query1.nameInp) {
      this.nameInp = this.query1.nameInp;
    }
    if (this.isMessage3 === "false") this.isMessage4 = this.isMessage3;
    this.orgUserMgeControllerSvr = new OrgUserMgeControllerSvr();
    this.total = this.dataList.length;
    this.loading = false;
    if (this.page) {
      this.pageSize = this.page.currtNum;
    }
    this.tableData = this.dataList.slice(
      this.pageSize * (this.currentPage - 1),
      this.pageSize * this.currentPage
    );

    this.$nextTick(function() {
      this.propertyValArr = [];
      if (this.hadSelectArr && !this.selectedArr.length) {
        for (var item of this.hadSelectArr) {
          this.dataList.forEach(row => {
            if (row.EaArea.EaAreaCode === item) {
              this.propertyValArr.push(row);
              this.$refs.houseTable.toggleRowSelection(row);
            }
          });
        }
      }
      if (this.selectedArr.length) {
        this.selectedArr.forEach(row => {
          this.propertyValArr.push(row);
          this.$refs.houseTable.toggleRowSelection(row);
        });
      }
    });
    //this.query();
    /* const queryParam = {
      Identif: "小区名称",
      numInp: "",
      nameInp: ""
    };
    this.$emit("query", queryParam); */
  },
  methods: {
    //当选中的物业区域已经拥有项目经理时，提示
    reminder(eaAreaCode, eaAreaName) {
      this.orgUserMgeControllerSvr
        .GetRealtyManagerByEaAreaCode(this.token, eaAreaCode)
        .then(res => {
          if (res) {
            if (this.isMessage4 === "true") {
              this.$message({
                message:
                  eaAreaName +
                  " 已经拥有项目经理，如果新增，请以最新项目经理为准",
                type: "warning"
              });
            }
          }
        });
    },
    //确定事件
    handelSure() {
      this.$store.state.areasTip = false;
      if (this.propertyVal) {
        this.$emit("propertyVal", this.propertyVal);
      } else if (this.propertyValArr) {
        this.$emit("propertyValArr", this.propertyValArr);
      }
    },
    doubleClick() {
      /* this.reminder(
        this.propertyVal.EaArea.EaAreaCode,
        this.propertyVal.EaArea.EaAreaName
      ); */

      this.$store.state.areasTip = false;
      this.$emit("propertyVal", this.propertyVal);
    },
    select(rows, row) {
      let selected = rows.length && rows.indexOf(row) !== -1;
      if (selected) {
        this.reminder(row.EaArea.EaAreaCode, row.EaArea.EaAreaName);
        this.propertyValArr.push(row);
      } else {
        for (var i = 0; i < this.propertyValArr.length; i++) {
          if (
            row.EaArea.EaAreaCode != this.propertyValArr[i].EaArea.EaAreaCode
          ) {
            this.propertyValArr1.push(this.propertyValArr[i]);
          }
        }
        this.propertyValArr = this.propertyValArr1;
      }

      //this.$emit("propertyValArr", this.propertyValArr);
    },
    selectAll(rows) {
      for (let item of rows) {
        this.reminder(item.EaArea.EaAreaCode, item.EaArea.EaAreaName);
      }
      this.propertyValArr = [];
      for (let item of rows) {
        this.propertyValArr.push(item);
      }
      //this.$emit("propertyValArr", this.propertyValArr);
    },
    //关闭弹窗
    tipHide() {
      this.$store.state.areasTip = false;
    },
    //分页
    pageCurrentChange(val) {
      this.currentPage = val;
      this.tableData = this.dataList.slice(
        this.pageSize * (this.currentPage - 1),
        this.pageSize * this.currentPage
      );
    },
    //控制每页大小
    handleSizeChange(val) {
      this.pageSize = val;
      this.tableData = this.dataList.slice(
        this.pageSize * (this.currentPage - 1),
        this.pageSize * this.currentPage
      );
    },
    //选取事件
    handleCurrentChange(val) {
      this.propertyVal = val;
    },
    //查询功能
    query() {
      const queryParam = {
        Identif: "小区名称",
        numInp: this.numInp,
        nameInp: this.nameInp
      };
      this.loading = true;
      this.$emit("query", queryParam);
    }
  }
};
</script>
<style lang="scss">
.housManage {
  .el-select-dropdown {
    z-index: 20000 !important;
  }
  .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
  }
}
</style>

<style lang="scss" scoped>
.housManage {
  height: 100%;
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.15);
    // opacity: 0.5;
    height: 100%;
    width: 100%;
    z-index: 1111;
  }
  .areaSelect {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: #fff;
    border: 1px solid #ccc;
    width: 920px;
    height: 436px;
    z-index: 2001;
    .head {
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      background: #f3f5f9;
      border-bottom: 1px solid #ccc;
      padding: 0 20px;
      align-items: center;
      .el-icon-close {
        font-weight: 600;
      }
    }
    .housManageNav {
      height: 40px;
      line-height: 40px;
      display: flex;
      background: #f3f5f9;
      border-bottom: 1px solid #ccc;
      align-items: center;
      .el-button {
        height: 34px;
        margin-left: 20px;
      }
    }
    .pagination {
      display: flex;
      flex-direction: row-reverse;
      height: 32px;
      // border-bottom: 1px solid #ccc;
    }
    .housManageFoot {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #f3f5f9;
      .btn {
        float: right;
        margin-right: 32px;
      }
    }
  }
}
</style>

